import { connect } from 'react-redux';
import LotDetails from './LotDetails';
import React from 'react';
import { ILinesHandle, ILinesProperties } from './LotDetails.properties';

const params = new URLSearchParams(location.search);

const mapStateToProps = () => ({
    selectedMovementEnquiryId: params.get('MovementId') || 0,
});

const ContainerComponent = (props: Omit<ILinesProperties, 'classes' | 'calculateCellValueChange'> & { forwardRef?: React.Ref<ILinesHandle> }) => {

    return <LotDetails
        {...props}
        innerRef={props?.forwardRef}
    />;
};

export default connect(mapStateToProps, null)(React.forwardRef(ContainerComponent));
